export const ACADEMY_THEMES = [
  {
    id: 'sky',
    name: 'Sky Blue',
    primary: '#0ea5e9',
    primaryDark: '#0369a1',
    primaryLight: '#e0f2fe',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'royal-blue',
    name: 'Royal Blue',
    primary: '#2563eb',
    primaryDark: '#1d4ed8',
    primaryLight: '#eff6ff',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'navy',
    name: 'Navy',
    primary: '#1e3a8a',
    primaryDark: '#1e2f6a',
    primaryLight: '#dbeafe',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'teal',
    name: 'Teal',
    primary: '#0d9488',
    primaryDark: '#0f766e',
    primaryLight: '#ccfbf1',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'emerald',
    name: 'Emerald',
    primary: '#059669',
    primaryDark: '#047857',
    primaryLight: '#d1fae5',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'forest',
    name: 'Forest Green',
    primary: '#166534',
    primaryDark: '#14532d',
    primaryLight: '#dcfce7',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'lime',
    name: 'Lime',
    primary: '#65a30d',
    primaryDark: '#4d7c0f',
    primaryLight: '#ecfccb',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'golden',
    name: 'Golden',
    primary: '#ca8a04',
    primaryDark: '#a16207',
    primaryLight: '#fef9c3',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'sunset',
    name: 'Sunset Orange',
    primary: '#ea580c',
    primaryDark: '#c2410c',
    primaryLight: '#ffedd5',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'crimson',
    name: 'Crimson',
    primary: '#dc2626',
    primaryDark: '#b91c1c',
    primaryLight: '#fee2e2',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'rose',
    name: 'Rose',
    primary: '#e11d48',
    primaryDark: '#be123c',
    primaryLight: '#ffe4e6',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'hot-pink',
    name: 'Hot Pink',
    primary: '#db2777',
    primaryDark: '#be185d',
    primaryLight: '#fce7f3',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'purple',
    name: 'Royal Purple',
    primary: '#7c3aed',
    primaryDark: '#6d28d9',
    primaryLight: '#ede9fe',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'indigo',
    name: 'Indigo',
    primary: '#4338ca',
    primaryDark: '#3730a3',
    primaryLight: '#e0e7ff',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'slate',
    name: 'Slate',
    primary: '#475569',
    primaryDark: '#334155',
    primaryLight: '#f1f5f9',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'steel',
    name: 'Steel',
    primary: '#52525b',
    primaryDark: '#3f3f46',
    primaryLight: '#f4f4f5',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'chocolate',
    name: 'Chocolate',
    primary: '#92400e',
    primaryDark: '#78350f',
    primaryLight: '#fef3c7',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'maroon',
    name: 'Maroon',
    primary: '#881337',
    primaryDark: '#6b1028',
    primaryLight: '#ffe4e6',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'cyan',
    name: 'Cyan',
    primary: '#0891b2',
    primaryDark: '#0e7490',
    primaryLight: '#cffafe',
    textOnPrimary: '#ffffff'
  },
  {
    id: 'violet',
    name: 'Violet',
    primary: '#6d28d9',
    primaryDark: '#5b21b6',
    primaryLight: '#ede9fe',
    textOnPrimary: '#ffffff'
  }
];

// Real per-academy Design Studio config — the subset of DEFAULT_PORTAL_CONFIG's fields
// that are actually theme/design choices (not identity/contact fields already backed by
// the academy record itself). Persisted server-side via academyAPI.get/updateDesignConfig,
// scoped to the real academyId — unlike DEFAULT_PORTAL_CONFIG below, which backs the
// standalone /elite demo fixture and its global kynaix_portal_elite localStorage key.
export const DEFAULT_DESIGN_CONFIG = {
  // The academy's theme, from the same set the profile menu offers. themeId
  // below is the older accent-only value the published page still reads; it
  // stays until that renderer moves across.
  themeKey: 'darkBlue',
  themeId: 'navy',
  heroStyle: 'fullscreen',
  cardStyle: 'elevated',
  fontPairing: 'modern',
  brandingMode: 'personalized',
  tagline: null,
};

export const DEFAULT_PORTAL_CONFIG = {
  academyId: '1',
  slug: 'elite',
  academyName: 'Elite Tennis Academy',
  tagline: 'Train Like a Champion',
  about: 'Premier tennis training for players of all skill levels. Our world-class coaches bring decades of professional and collegiate experience to every session. Whether you are picking up a racket for the first time or refining your game for competition, our structured programs are designed to help you reach your full potential in a supportive and motivating environment.',
  logo: null,
  themeId: 'navy',
  features: {
    feed: false,
    squads: false,
    gallery: true,
    schedule: true
  },
  brandingMode: 'personalized',
  heroStyle: 'fullscreen',
  cardStyle: 'elevated',
  fontPairing: 'modern',
  contact: {
    address: '123 Sports Blvd, Los Angeles, CA 90001',
    phone: '(555) 123-4567',
    email: 'info@elitetennisacademy.com',
    website: 'https://elitetennisacademy.com',
    instagram: 'elitetennisla',
    facebook: 'EliteTennisAcademy',
    twitter: ''
  }
};

export function getPortalConfig() {
  try {
    const stored = localStorage.getItem('kynaix_portal_elite');
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...DEFAULT_PORTAL_CONFIG,
        ...parsed,
        features: { ...DEFAULT_PORTAL_CONFIG.features, ...(parsed.features || {}) },
        contact: { ...DEFAULT_PORTAL_CONFIG.contact, ...(parsed.contact || {}) }
      };
    }
  } catch (e) {
    // ignore parse errors
  }
  return { ...DEFAULT_PORTAL_CONFIG };
}

export function savePortalConfig(config) {
  localStorage.setItem('kynaix_portal_elite', JSON.stringify(config));
}

export function savePreviewConfig(config) {
  localStorage.setItem('kynaix_portal_elite_preview', JSON.stringify(config));
}

export function getPreviewConfig() {
  try {
    const stored = localStorage.getItem('kynaix_portal_elite_preview');
    if (stored) return JSON.parse(stored);
  } catch (e) {}
  return null;
}

export function clearPreviewConfig() {
  localStorage.removeItem('kynaix_portal_elite_preview');
}
